import { render } from "./section-three.vue?vue&type=template&id=427c82cb&scoped=true"
import script from "./section-three.vue?vue&type=script&lang=js"
export * from "./section-three.vue?vue&type=script&lang=js"

import "./section-three.vue?vue&type=style&index=0&id=427c82cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c82cb"]])

export default __exports__